import { get, set } from 'global/lib/lodash';
import sendData from './sendData';
import { awaitAll } from 'global/utils/awaitAll';

export const UploadFiles = async (data, opts = {}) => {
  return new Promise(async (resolve, reject) => {
    //data should come over in the jsonapi format
    // example
    // data = {
    //   data: {
    //     attributes: {
    //       images: []
    //     }
    //   }
    // }

    opts = {
      attributeType: 'images',
      isImage: true,
      shouldUpdate: true,
      ...opts,
    };

    const dataType = get(data, 'data.type');

    let singularType = dataType;

    switch (dataType) {
      case 'comments':
        singularType = 'comment';
        break;
      case 'realms':
        singularType = 'realm';
        break;
      case 'tasks':
        singularType = 'task';
        break;
      case 'scorecard-scores':
        singularType = 'scorecard-score';
        break;
      case 'checkpoints':
        singularType = 'checkpoint';
        break;
      case 'checklists':
        singularType = 'checklist';
        break;
      case 'step-by-step-items':
        singularType = 'step-by-step-item';
        break;
      case 'sub-scores':
        singularType = 'sub-score';
        break;
    }

    const files = get(data, `data.attributes.${opts.attributeType}`, []);
    const errors = [];

    const collection_name = opts.collection_name || `${singularType}-images`;

    const resps = !opts.shouldUpdate
      ? files
      : await awaitAll(
          files.map((img) => () => async () => {
            let resp;
            const isNew = !img.id || get(img, 'id', '').toString().indexOf('_file_') > -1;

            const isReference = !!img.mediaId;

            if (isReference) {
              img.id = img.mediaId;
              delete img.mediaId;

              if (!img.hasChanged) {
                return img;
              }
            }

            if (!isNew) {
              const id = img.id.toString();
              resp = await sendData({
                url: `/media/${id}`,
                method: 'patch',
                data: {
                  data: {
                    id,
                    type: 'media',
                    attributes: {
                      order_column: img.order_column,
                      custom_properties: {
                        ...(img.custom_properties || {}),
                        caption: img.caption || '',
                      },
                    },
                  },
                },
              });
            } else {
              const imgfile = img.file || img;
              const s3upl = await uploadFileToS3(imgfile);
              const name = get(imgfile, 'name', img.name);

              resp = await sendData({
                url: `/media`,
                method: 'post',
                data: {
                  data: {
                    type: 'media',
                    attributes: {
                      order_column: img.order_column,
                      name,
                      file_name: name,
                      collection_name: img.collection || collection_name,
                      source: 's3_path',
                      caption: img.caption || '',
                      content: `tmp/${get(s3upl, 'Key')}`,
                      custom_properties: opts.isImage
                        ? {
                            caption: img.caption || '',
                            generated_conversions: {
                              large: true,
                              thumb: true,
                            },
                          }
                        : undefined,
                    },
                  },
                },
              });
              const respdata = get(resp, 'data.data');
              set(img, 'file._file', respdata);
            }
            return get(resp, 'data.data');
          }),
          { queueSize: 5 }
        );

    set(data, `data.attributes.${opts.attributeType}`, undefined);
    set(
      data,
      `data.relationships.${opts.attributeType}.data`,
      resps.map((res, i) => ({ id: res.id.toString(), type: 'media' }))
    );
    resolve({ errors, data: resps });
  });
};

export const getSignedUrl = async (file) => {
  const Key = `${Date.now()}_${file.path}`;

  const { data } = await sendData(
    {
      url: '/sign-s3-upload',
      method: 'POST',
      data: { data: { file_name: Key } },
    },
    { useNamespace: false }
  );

  const uploadURL = get(data, 'data.uri');

  return {
    uploadURL: uploadURL,
    Key,
  };
};

export const uploadFileToS3 = async (file) => {
  const { uploadURL, Key } = await getSignedUrl(file);

  const response = await fetch(uploadURL, {
    method: 'PUT',
    body: file,
  });

  return {
    response,
    Key,
    file,
  };
};
